/**
 * Zahlen hochzählen: jedes Element mit der Klasse .counter zählt einmalig von 0 auf
 * seinen Zielwert, sobald es in den sichtbaren Bereich scrollt.
 *
 * - Zielwert = die erste Zahl im Text des Elements. Text davor/danach bleibt stehen
 *   („über 1.250 Kunden", „98 %", „2,5 Mrd. €").
 * - Deutsches Zahlenformat: Punkt = Tausendertrenner, Komma = Dezimaltrenner.
 *   Nachkommastellen und Tausenderpunkte werden wie im Ausgangstext übernommen.
 * - Inneres Markup (<strong>, <span> …) bleibt erhalten, es wird nur der Textknoten
 *   mit der Zahl verändert.
 * - Ohne JS oder bei „Bewegung reduzieren" steht sofort der Endwert da.
 * - Optional am Element: data-counter-duration="3000" (ms), data-counter-start="100".
 */
(function () {
    var DURATION = 2000; // ms
    var NUMBER = /\d[\d.]*(?:,\d+)?/; // erste Zahl im deutschen Format

    document.addEventListener("DOMContentLoaded", function () {
        var elements = document.querySelectorAll(".counter");
        if (!elements.length) return;

        var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduceMotion || !("IntersectionObserver" in window)) return; // Endwert bleibt stehen

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    observer.unobserve(entry.target); // nur einmal zählen
                    run(entry.target.__counter);
                });
            },
            { threshold: 0.4 }
        );

        elements.forEach(function (el) {
            var counter = prepare(el);
            if (!counter) return;
            el.__counter = counter;
            render(counter, counter.start); // Startwert zeigen, bis das Element sichtbar wird
            observer.observe(el);
        });
    });

    // Textknoten mit der Zahl finden und Zielwert + Format daraus ableiten.
    function prepare(el) {
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
            var match = NUMBER.exec(node.nodeValue);
            if (!match) continue;

            var raw = match[0].replace(/\.+$/, ""); // Satzpunkt am Ende gehört nicht zur Zahl
            var parts = raw.split(",");
            var intPart = parts[0];
            var decimals = parts[1] ? parts[1].length : 0;
            var grouping = /^\d{1,3}(\.\d{3})+$/.test(intPart);

            // Punkt ohne Tausender-Muster und ohne Komma = Dezimalpunkt („3.5")
            if (!grouping && !decimals && intPart.indexOf(".") !== -1) {
                var p = intPart.split(".");
                intPart = p[0];
                decimals = p[1].length;
                parts[1] = p[1];
            }

            var target = parseFloat(intPart.replace(/\./g, "") + (decimals ? "." + parts[1] : ""));
            if (isNaN(target)) return null;

            var text = node.nodeValue;
            return {
                node: node,
                before: text.slice(0, match.index),
                after: text.slice(match.index + raw.length),
                target: target,
                start: parseFloat(el.getAttribute("data-counter-start")) || 0,
                duration: parseInt(el.getAttribute("data-counter-duration"), 10) || DURATION,
                decimals: decimals,
                grouping: grouping,
            };
        }
        return null;
    }

    function render(counter, value) {
        counter.node.nodeValue =
            counter.before +
            value.toLocaleString("de-DE", {
                minimumFractionDigits: counter.decimals,
                maximumFractionDigits: counter.decimals,
                useGrouping: counter.grouping,
            }) +
            counter.after;
    }

    function run(counter) {
        var startTime = null;

        function frame(now) {
            if (startTime === null) startTime = now;
            var t = Math.min((now - startTime) / counter.duration, 1);
            var eased = 1 - Math.pow(1 - t, 3); // easeOutCubic: schnell starten, weich auslaufen
            render(counter, counter.start + (counter.target - counter.start) * eased);
            if (t < 1) {
                requestAnimationFrame(frame);
            } else {
                render(counter, counter.target); // exakt auf dem Zielwert enden
            }
        }

        requestAnimationFrame(frame);
    }
})();
